import { css } from '@emotion/core'

const gr = ({ theme }) => css`
  fill: black;
  height: 1rem;
  width: 1rem;
`
export default gr
